import { ActivityLogParser } from '@/parsers/activityLog'
import { i18n } from '@/i18n'
import upperFirst from 'lodash/upperFirst'

export class ApplicationActivityLogParser extends ActivityLogParser {
    static attributeDataTypes = {
        'is_change_application': 'boolean',
        'on_hold_until': 'date',
        'submission_send_date': 'date',
        'submission_response_date': 'date',
    }

    static getLogDescriptionCreated (activityLog, data) {
        const interpolationParams = {
            someone: data.causer,
            something: `<b>${i18n.tc(`common.change-log.subject.${activityLog.isSubjectRelation ? 'some--target' : 'this'}.${activityLog.properties?.attributes?.is_change_application ? 'change-' : ''}application`, 1)}</b>`,
        }
        if (data.causer) {
            return i18n.t(`common.change-log.someone-${activityLog.isSubjectRelation ? 'added' : 'created'}-something`, interpolationParams)
        } else {
            return i18n.tc(`common.change-log.something-has-been-${activityLog.isSubjectRelation ? 'added' : 'created'}`, activityLog.attributeKeys.length, interpolationParams)
        }
    }

    static getLogDescriptionUpdated (activityLog, data) {
        const interpolationParams = {
            someone: data.causer,
            something: `${i18n.tc('common.change-log.subject.this.field', activityLog.attributeKeys.length)} <b>${activityLog.attributeLabels}</b>`,
            ofSomething: `${i18n.tc(`common.change-log.subject.of-some.${activityLog.properties?.attributes?.is_change_application ? 'change-' : ''}application`, 1)}`,
        }
        if (data.causer) {
            return i18n.t(`common.change-log.someone-updated-something${activityLog.isSubjectRelation && !this.hideSubjectRelationInLogDescription ? '-of-something' : ''}`, interpolationParams)
        } else {
            return upperFirst(i18n.tc(`common.change-log.something${activityLog.isSubjectRelation && !this.hideSubjectRelationInLogDescription ? '-of-something' : ''}-has-been-updated`, activityLog.attributeKeys.length, interpolationParams))
        }
    }

    static getLogDescriptionDeleted (activityLog, data) {
        const interpolationParams = {
            someone: data.causer,
            something: `<b>${i18n.tc(`common.change-log.subject.${activityLog.isSubjectRelation ? 'some--target' : 'this'}.${activityLog.properties?.old?.is_change_application ? 'change-' : ''}application`, 1)}</b>`,
        }
        if (data.causer) {
            return i18n.t(`common.change-log.someone-deleted-something`, interpolationParams)
        } else {
            return upperFirst(i18n.tc(`common.change-log.something-has-been-deleted`, activityLog.attributeKeys.length, interpolationParams))
        }
    }

    static showLogDetailsCreated = true
    static showLogDetailsDeleted = true
}
